import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Container, ListGroup } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  tagline,
  title,
  description,
  items,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.ConnectedList)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2n:x0:z0" image={bg_1} className={classes.bg_1} />
      <Container fluid="md">
        <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
          <span dangerouslySetInnerHTML={{ __html: tagline }} />
        </Tagline>
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description" className="d-block mb-3">
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
        <ListGroup>
          {items.map((item, idx) => (
            <ListGroup.Item key={idx}>
              <EditableText path={`item_${idx}`}>
                <div dangerouslySetInnerHTML={{ __html: item }} />
              </EditableText>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Container>
    </div>
  );
}
